import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeCountryListItem extends SearchModelBase {
    isoCode: string = '';
    countryName: string = '';
    usCode: string = '';
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'ISO Code', width: 70, dataIndex: 'isoCode'}),
        XCol.Create({ col: 1, text: 'Country', width: 500, dataIndex: 'countryName', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'US Code', width: 60, dataIndex: 'usCode'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeCountryListItem.prototype.isoCode, orderByAscending: true };

    public static formatData(data: CodeCountryListItem[]) {
        return data.map((d: CodeCountryListItem) => ({
          ...d,
        }));
    }

}
